// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"675":"efaa7e8b","803":"ebac26c9"}[chunkId] + ".chunk.js";
};